const GET_bannerHeight_16_9 =(width)=>{
    const _width = Number(width) | Number(window.screen.width)
    if(_width){
        return Math.round(_width * 9/16)
    }
}
export default {
    GET_bannerHeight_16_9
}